import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip as RechartsTooltip,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";
// components
import CustomYAxisTick from "./components/custom-y-axis-tick";
import RoundedBar from "./components/rounded-bar";
import CustomXAxisTick from "./components/custom-x-axis-tick";
import CustomReferenceLine from "./components/custom-reference-line";
// utils
import getAverageEarnings from "./utils/getAverageEarnings";

type Props = {
  type: string;
  chartData: (RangeEarningsEntry & { earningsToDisplay: number })[];
  xTicks: number[] | string[];
};

const MIN_Y = 20;

const BABarChart = ({ type, chartData, xTicks }: Props) => {
  return (
    <ResponsiveContainer width="100%" height={"100%"}>
      <ComposedChart data={chartData} margin={{ left: 60, top: 20, right: 70 }}>
        <XAxis
          dataKey={"x"}
          tickLine={false}
          axisLine={false}
          interval={0}
          ticks={xTicks}
          tickCount={xTicks.length}
          type={"number"}
          domain={[xTicks[0], xTicks[xTicks.length - 1]]}
          tick={(props) => <CustomXAxisTick {...props} filterType={type} />}
        />
        <YAxis
          dataKey="earningsToDisplay"
          tickLine={false}
          axisLine={false}
          width={40}
          tick={CustomYAxisTick}
          tickCount={5}
          domain={
            !chartData.length ||
            chartData.every((el) => el.earningsToDisplay < MIN_Y)
              ? [0, MIN_Y]
              : [0, "auto"]
          }
        />
        {/* need this to keep chart interactive */}
        <RechartsTooltip content={() => null} cursor={false} />
        <Bar
          dataKey="earningsToDisplay"
          barSize={24}
          shape={(props) => <RoundedBar {...props} filterType={type} />}
        />

        <ReferenceLine
          shape={CustomReferenceLine}
          y={getAverageEarnings(chartData)}
          isFront={true}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default BABarChart;
